module.exports = __webpack_public_path__ + "static/img/1-2.0384740.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/1-2.png
// module id = fUca
// module chunks = 0